import { CLIENT_ENUM_TO_TYPES_MAP } from '../../shared/constants'
import { sendEmail } from '../Country/Page/Pipeline/PipelineView/graphQL'

export const normalizeStatus = value => {
  const status = value ? 'DELETED' : 'ACTIVE'
  return CLIENT_ENUM_TO_TYPES_MAP[status]
}

const getGM = countryCode => {
  switch (countryCode) {
    case 'AU':
    case 'NZ':
      return 'raphael@oppizi.com'
    case 'UK':
    case 'ES':
    case 'IT':
    case 'PL':
      return 'nicolas@oppizi.com'
    case 'US':
    case 'CA':
    case 'MX':
      return 'arthur@oppizi.com'
    case 'BE':
    case 'NL':
    case 'FR':
      return 'vincent@oppizi.com'
    case 'DE':
      return 'gaelle@oppizi.com'
    default:
      return null
  }
}

export const getXeroRecipient = countryCode => {
  const cfo = 'sami@oppizi.com'
  const recipients = [cfo]
  const gm = getGM(countryCode)

  if (gm) {
    recipients.push(gm)
  }

  return recipients
}

export const sendEmailChangeClientNameToGMsAndCFO = async ({
  newName,
  client,
  country,
  user,
}) => {
  const countryCode = country.code
  await sendEmail({
    input: {
      sender: user.email,
      recipients: getXeroRecipient(countryCode),
      cc: [],
      bcc: [],
      subject: 'Client name changed without Xero connection',
      body: JSON.stringify([
        {
          'type': 'paragraph',
          'align': 'left',
          'children': [{ 'text': 'Hello.' }],
        },
        {
          'type': 'paragraph',
          'align': 'left',
          'children': [{ 'text': '' }],
        },
        {
          'type': 'paragraph',
          'align': 'left',
          'children': [
            {
              'text': `User ${user.firstName} ${user.lastName} (${user.role}) ${
                user.email
              }`,
            },
          ],
        },
        {
          'type': 'paragraph',
          'align': 'left',
          'children': [
            { 'text': 'Change client name without Xero connection' },
          ],
        },
        {
          'type': 'paragraph',
          'align': 'left',
          'children': [{ 'text': '' }],
        },
        {
          'type': 'paragraph',
          'align': 'left',
          'children': [{ 'text': `Old client name - ${client.name}` }],
        },
        {
          'type': 'paragraph',
          'align': 'left',
          'children': [{ 'text': `New client name - ${newName}` }],
        },
      ]),
    },
  })
}
